import { Service } from '@roc/client-portal-shared/services';

const url = {
  GET_REGISTRATION_ENABLED: '/api/v1/user/public/getRegistrationEnabled'
};

export class RegisterService extends Service {
  getRegistrationEnabled() {
    const _url = url.GET_REGISTRATION_ENABLED;
    return this.get(_url);
  }
}
